import type { Source, SourceRegistry } from "./types.ts";

export const WIKIDATA_ENDPOINT = "https://query.wikidata.org/sparql";

export function createWikidataSource(): Source {
  return {
    id: "wikidata",
    label: "Wikidata",
    kind: "sparql-endpoint",
    endpoint: WIKIDATA_ENDPOINT,
    backendId: "wikidata",
    isDefault: true,
    description: "The Wikidata Query Service — the whole of Wikidata's knowledge graph.",
  };
}

export class InMemorySourceRegistry implements SourceRegistry {
  private sources = new Map<string, Source>();

  constructor(initial: Source[] = []) {
    for (const s of initial) this.register(s);
  }

  register(source: Source): void {
    this.sources.set(source.id, source);
  }

  remove(id: string): void {
    this.sources.delete(id);
  }

  list(): Source[] {
    return [...this.sources.values()];
  }

  get(id: string): Source | undefined {
    return this.sources.get(id);
  }

  defaultSource(): Source {
    const marked = this.list().find((s) => s.isDefault);
    const first = marked ?? this.list()[0];
    if (!first) throw new Error("SourceRegistry is empty — register at least one source.");
    return first;
  }
}
